export default __webpack_public_path__ + "images/0a4628dd139e459c6a1dc6c244b3046b-education.jpg";